import React from 'react';

export const notFound = (intl, colSpan) => (
	<tr key={1} className="not-found">
		<th colSpan={colSpan || '16'}>
			<span>{intl('По Вашему запросу нет данных')}...</span>
		</th>
	</tr>
);

export const showMoreRows = (onShowMore, ComponentName, intl) => (
	<tr className="show-more">
		<th colSpan="16">
			<a
				href="#"
				className="icon-show-more font-proxima-nova-regular"
				onClick={e => {
					e.preventDefault();
					onShowMore(ComponentName);
				}}
			>
				<span>
					{intl('Показать ещё')}
				</span>
			</a>
		</th>
	</tr>
);
export const showMoreRowsDiv = (onShowMore, ComponentName, intl) => (
	<div className="show-more">
		<a
			href="#"
			className="icon-show-more font-proxima-nova-regular"
			onClick={e => {
				e.preventDefault();
				onShowMore(ComponentName);
			}}
		>
			<span>
				{intl('Показать ещё')}
			</span>
		</a>
	</div>
);

const getSortClass = (activeSortColumn, currentColumnId, customClass, disabled=false) => {
	const { id, direction } = activeSortColumn;
	const className = ['sort-header'];

	if (disabled) return 'comment disabled';
	if (customClass) className.push(customClass);

	if (id === currentColumnId && direction === 'desc') {
		className.push('ordered ordered-desc');
	} else if (id === currentColumnId && direction === 'asc') {
		className.push('ordered ordered-asc');
	}

	return className.join(' ');
};

export const mapTableSortHeaders = options => {
	const { headers, columnSorting, sortByColumn, intl, isHiddenRub } = options;
	const isRocket = process.env.CPA_ENV === 'rocket';
	return headers.map(item => {
		const columnTitle = isRocket && item.title === 'Поинты' ?  'QUID' : item.title;

		if (item.id === 'balance_rub' && isHiddenRub) {
			return null;
		}

		return (
			<span
				key={item.id}
				className={
					item.position
						? getSortClass({ id: item.id, direction: columnSorting.direction },
							columnSorting.key,
							item.className,
							item.disabled)
						: item.className || ''
				}
				onClick={e => {
					item.position && sortByColumn(item.id);
				}}
			>
				{intl(columnTitle)}
			</span>
		);
	});
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/table-helpers.js